/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

export const PAGE_NAME_PRIVACY_POLICY = 'PrivacyPolicyPage';
export const FALLBACK_URL_PRIVACY_POLICY = 'privacy-policy';
export const COMMERCE_PAGE_VIEW_NAME_REDIRECT = 'RedirectView';
export const COMMERCE_PAGE_VIEW_NAME_SEARCH = 'SearchDisplayView';
